import { render } from "./DollarCoinsStackedIcon.vue?vue&type=template&id=1349ce2d"
const script = {}

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__